import React from "react";
import "./articledetail.scss";
import Globals from "../../api";
import { Suspense, lazy } from "react";
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
//import Article_bottom_text from '../ad-units/article_bottom_text';
//import ROS_Left_336_280 from '../ad-units/Ros_left_300_250';
import ROS_Middle_Center_728_90 from '../ad-units/ros_middle_center_728_90';
import Ros_bottom_center_728_90 from '../ad-units/Ros_bottom_center_728_90';
import ROS_Top_Center_728_90 from '../ad-units/Ros_top_center_728_90';
import ReactHtmlParser from "react-html-parser";
//import RelatedArticle from "../../components/RelatedArticle/relatedarticle";
import Rightbar from "../../components/Rightbar/Rightbar";
import { Helmet } from "react-helmet";
import ImageConvertionDefault from "../../config";
import $ from "jquery";

export default class ArticleDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Articledata: [],
      videos: [],
      meta: [],
      title: [],
      meta_keywords: [],
      meta_description: [],
      AdUnits : [],
      Ogimage :[],
      Domainurl : [],
      Horoscope :[],
      Rightbar : [], 
      googleAds : [],
      CricketData : [],
      IsVideoArticle : [],
      VideoArticleUrl :[]
    };
  }
  getHoroscope() {
    // console.log('api at header' + Globals.language_based_api);
        const url= Globals.language_based_api+'/home-page';
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
          
            this.setState({
              Horoscope : data.Contents
            })
        }) 
      }

      getGoogleAds(){
        const url= Globals.AdConfig;
                 fetch(url)
                .then((res) => res.json())
                .then((data) => {
                  
                    this.setState({
                      googleAds : data.AdContents[0].ROS
                    })
                    
                }) 
                
      }
  getAds(){
    const url = Globals.Ad_api;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          AdUnits: data.AdContents[0].header_sponsor_logo,
        });
      });
  }
  getRightbar(){
    let URI = window.location.pathname;
    const url = Globals.Rightbar_api+URI;
    //const url = Globals.Rightbar_api;
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          Rightbar: data.Contents[0]
        });
      });
  }

  getCricketUpdate(){
    const url= Globals.Cricket_update_api;
    //const url ="https://m-marathidev.webdunia.com/ad-config/ticker-test.json";
    fetch(url)
    .then((res) => res.json())
    .then((data) => {
        this.setState({
          CricketData : data.CurrentMatches
          
        })
    })   
    //console.log("url ",url)
  }
  
  componentDidMount() {
    let URI = window.location.pathname;
    let url;
    if(window.location.pathname == "/hindu-religion/solar-eclipse-effects-121113000001_1.html"){
      url = 'http://ws-uat.webdunia.com/json/page?lang=hi&url=/hindu-religion/solar-eclipse-effects-121113000001_1.html'; 
   }
   else{
      url = Globals.language_based_api + URI;
   }
    fetch(url)
      .then((res) => res.json())
      .then((data) => {

        var VideoArticleData = data.Contents.filter(e=>e.Type === "Article")[0].VideoOnTop;
        // var VideoArticleData = (data.Contents.filter(e=>e.Type === "Article")[0] != 'undefined') ? data.Contents.filter(e=>e.Type === "Article")[0].VideoOnTop : '';
        var VideoArticleUrl = data.Contents.filter(e=>e.Type === "Article")[0].VideoUrl;

        this.setState({
          IsVideoArticle : VideoArticleData,
          VideoArticleUrl :VideoArticleUrl,
          Articledata: data.Contents,
          meta: data.Meta,
          title: data.Title,
          meta_keywords: data.Meta.keywords.Attributes.content,
          meta_description: data.Meta.description.Attributes.content,
          Ogimage: data.Contents[2].Thumbnail,
          Domainurl : data.Contents[2].Url
        });
      });
      this.getHoroscope();
      this.getAds();
      this.getRightbar();
      this.getGoogleAds();
      this.getCricketUpdate();
  }
  

  
  render() {
    var checkonce = 1;
   const FilterHtmlContent = (item) => {
      if (item.Type == "Video") {
        return (
          <div>
            {" "}
            {/* <iframe
              className="Youtube-iframe"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              src={item.EmbedUrl}
            ></iframe> */}
            <LiteYouTubeEmbed 
            className="Youtube-iframe"
            id={item.EmbedUrl.split("/").pop()}
            title="youtube embed"
            poster="mqdefault"
            webp = {true}
    />
          </div>
        );
      }
      if (item.Type == "Image") {
        return (
          <>
          <div className="arti_img">
            <img src={ImageConvertionDefault(item.Path)} alt={ (typeof item.alttext != "undefined" ? item.alttext  : "webdunia")}  />
          </div>
          {(() => {
                if (checkonce == 1) {
                  return (
                    <Suspense fallback={renderLoader()}>   
            <div className="full_ads_block">
            <Ros_bottom_center_728_90 AdData = {this.state.googleAds}/> 
            </div>
            </Suspense>
                  )
                }
              })()}

           
            </>
        );
      }
      checkonce = 0 ;
      if (item.Type == "AdSpace" && item.Index == 1 ) {
        return (
          <>
          {/* <div id="M598980ScriptRootC934514"> </div> */}
          {/* <div className="ad_in_between1"> */}
            {/* <ROS_Left_336_280 AdData = {this.state.googleAds}/> */}
          <Suspense fallback={renderLoader()}>   
          <Helmet>
          <script src="https://jsc.mgid.com/t/a/tamil.webdunia.com.934571.js" async></script>
          </Helmet>
          <div id="M598982ScriptRootC934571"></div>

          <br/>
          <div id="aniview_player" style={{ margin: '0 auto ', marginBottom : '20px' , marginTop : '20px' , maxWidth :'450px' , clear : 'both'}}></div>
          </Suspense>
          </>
        );
      }

      if (item.Type == "FreeHtml") {
        var Html = item.Html;

        var Html_Content = Html.replace('<div style="text-align: justify;"><div>', "<br />");
        var Html_Content = Html_Content.replace('<div style="text-align: justify;">&nbsp;</div>', "<br />");
        //console.log("html_com :" , Html_Content)
        return (
<>
<Helmet>
<script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
<script async src="https://www.instagram.com/embed.js"></script>
<script src="https://jsc.mgid.com/t/a/tamil.webdunia.com.934576.js" async></script>
</Helmet>

{ReactHtmlParser(Html_Content)}
</>
        );
      }
    }
    //console.log("Rightbar",this.state.googleAds);
    const renderLoader = () => <div className="loading_screen"></div>;
    let Articledata = this.state.Articledata;
    let ArticledataFull = Articledata;
    let PagelistData = ArticledataFull.filter((x) => x.Type === "PageList");
    let relatedNews = PagelistData.slice(1, 2);
    let ArticleContent = ArticledataFull.filter((x) => x.Type === "Article");
    let ArticleContentCC = ArticleContent;
    // const SearchTags = [];
    const ArticledataFullItems = ArticleContentCC.map((item, i) => {
      const propertyName = [item.RelatedArticles];
      return (
        <div key={i}>
          <div className="article_sticky_sect sticky-top">
            <div className="arti_written">
              <span>Written By</span> {item.AuthorName || "N.A."}
            </div>

            <div className="arti_date">
              <span>Last Updated:</span> {item.DateTime}
            </div>
            <div className="arti_social_block">
              <ul>
                <li>
                  <a
                    href={
                      "https://www.facebook.com/share.php?u=" +
                      item.Url +
                      "&utm_source=facebook&utm_medium=social&utm_campaign=fbshare"
                    }
                    title={item.Title}
                    target="_blank"
                    className="art_fb_icon"
                  ></a>
                </li>
                <li>
                  <a
                    href={
                      "https://twitter.com/intent/tweet?status=" +
                      item.Title +
                      "+&url=" +
                      item.Url +
                      "&utm_source=twitter&utm_medium=social&utm_campaign=twshare"
                    }
                    className="art_tw_icon"
                  ></a>
                </li>
                <li>
                  <a
                    href={
                      "https://api.whatsapp.com/send?text=" +
                      item.Title +
                      " / " +
                      item.Url +
                      "&utm_source=whatsapp&utm_medium=social&utm_campaign=washare"
                    }
                    className="art_whapp_icon"
                  ></a>
                </li>
                <li>
                  {/* <a href="" className="art_email_icon"></a> */}
                </li>
              </ul>
            </div>
            {/* { const array = [item.RelatedArticles] ; } */}
            {
                (() => {
                  if (propertyName[0] != null ) {
                  return (
                   propertyName.map((item, i) => (
                <div className="next_article_block" key={i}>
                  <h3>அடுத்த கட்டுரை</h3>
                  <ul>
                    {item.Items.map((item, i) => (
                      <li key={i}>
                        <a href={item.Url}>{item.Title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))
                 
                  )
                }})()}
          </div>
          <div className="article_content">
            <div className="article_in_content">
              <div className="article_title ">
                <h1>{item.Title}</h1>
              </div>
              {(() => {
                if (this.state.IsVideoArticle == 'yes' && typeof this.state.VideoArticleUrl != 'undefined') {
                 let regex = /(?<=src=").*?(?=[\*"])/;
                 var src =  this.state.VideoArticleUrl.match(regex);
                  //var src = $("iframe").attr("src").split('?')[0];
                 // console.log("src",src)
                  return (
                    <div className="container" style = {{paddingBottom : "15px"}}> 
                    <LiteYouTubeEmbed 
              style = {{width : "320px", height : "270px" ,padding : "5px"}}
              id={src[0].split("/").pop()}
            title="youtube embed"
            poster="mqdefault"
            webp = {true}
    />
                    {/* {ReactHtmlParser(this.state.VideoArticleUrl)} */}
                    <br />
                    </div>
                  )
                }
              })()} 

              {item.Contents.map((item, i) => {
                if (item.Type == "KeywordCloud") {
                  this.SearchTags = item.Pages;
                }
                return (
                 <>
                    {FilterHtmlContent(item)}
                  </>
                );
              })}
            </div>
            <div className="readmore_tags">
              <ul className="readm_tags_list">
                <li>
                  <span>மேலும் படிக்க :</span>
                </li>
                {this.SearchTags.map((item, i) => (
                  <li key={i}>
                    <a href={item.Url}>{item.Title}</a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
            
          {/* <Ros_bottom_center_728_90 AdData = {this.state.googleAds} /> */}
        </div>
            {/* <div> <Article_Middle_728_90 AdsData={this.state.AdUnits}/></div> */}
           
          </div>
        </div>
      );
    });
   //console.log("ddsadnsad",this.state.Domainurl);
    return (
      <>
       <div className="full_ads_block">
                 <Suspense fallback={renderLoader()}>
               <ROS_Top_Center_728_90 AdData= {this.state.googleAds} />
             </Suspense>
             </div>
      <div className="article_detail ">
        <Helmet>
        <script async id="AV61165f57fd04ff16776d13e1" type="text/javascript" src="https://tg1.aniview.com/api/adserver/spt?AV_TAGID=61165f57fd04ff16776d13e1&AV_PUBLISHERID=6072c4c6f50b1d56f001c8ad"></script>
        <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
        <script async src="https://www.instagram.com/embed.js"></script> 
        
        </Helmet>
       
        <div className="container">
          <div className="row ">
            <div className="col">
              <div className="aritcle_container">{ArticledataFullItems}</div>
              
              <div id="ad_video_player"></div>
              <br/>
              
              
              <div className="article_after_seciton">
              <div className="full_ads_block">
                 <Suspense fallback={renderLoader()}>
               <ROS_Middle_Center_728_90 AdData= {this.state.googleAds} />
             </Suspense>
             </div>
             <div id="M598982ScriptRootC934576" className="m-t-20"> </div>

                {/* <RelatedArticle dataFromParent={relatedNews} /> */}
                <br />
             
                {/* <Article_bottom_text  /> */}
             
              </div>
            </div> 
            <div className="col right_side_bar">
           <Rightbar Rightbar = {this.state.Rightbar} googleAds = {this.state.googleAds}  CricketData = {this.state.CricketData}
           />
           </div>
          </div>
        </div>
      </div>
      </>
    );
  }
}
